import { createSlice } from "@reduxjs/toolkit";
import { signupAPI } from "../../../api/publicApi";
import { showErrorToast, showSuccessToast } from "../../../utils/toast";

const data = {
  isLoading: false,
  error: "",
  message: null,
  data: null,
};

const signupSlice = createSlice({
  name: "signup",
  initialState: data,
  reducers: {
    signupSlice(state) {
      state.isLoading = true;
    },
    signupSliceSuccess(state, action) {
      state.isLoading = false;
      state.data = action.payload;
      state.message = null;
    },
    signupSliceFailure(state, action) {
      state.isLoading = false;
      state.data = action.payload;
      state.message = action.payload;
    },
    signupSliceReset(state) {
      state.isLoading = false;
      state.message = null;
      state.data = null;
      state.error = "";
    },
  },
});

export const signupUserHandler = (data: any) => async (dispatch: any) => {
  try {
    dispatch(signupUserAction.signupSlice());
    const response: any = await signupAPI(data);
    showSuccessToast(response?.message);
    dispatch(signupUserAction.signupSliceSuccess(response));
  } catch (e: any) {
    showErrorToast(e?.response?.data?.error_message)
    dispatch(signupUserAction.signupSliceFailure(e?.response?.data));
  }
};
export default signupSlice.reducer;
export const signupUserAction = signupSlice.actions;
